define('ProductDetails.Full.View.Extension', [
  'ProductDetails.Full.View',

  'Backbone',
  'jQuery',
  'Utils',
  'underscore'
], function (
  ProductDetailsFullView,

  Backbone,
  jQuery,
  Utils,
  _
) {
  'use strict';

  _.extend(ProductDetailsFullView.prototype, {
    initialize: _.wrap(ProductDetailsFullView.prototype.initialize, function (fn) {
      fn.apply(this, _.toArray(arguments).slice(1));

      jQuery(function () {
        this.$('.inventory-display-quantity-available').hide();
      });

      this.on(
        'afterViewRender, afterCompositeViewRender',
        function () {
          var itemLowStock = this.$(
            '.inventory-display-stock-information-low-stock, .inventory-display-stock-information-back-order'
          );

          if (itemLowStock) {
            this.$(
              '.inventory-display-stock-information-low-stock.inventory-display-message-text, .inventory-display-stock-information-back-order.inventory-display-message-text'
            )
              .removeClass()
              .addClass('product-line-stock-msg-low');
            this.$(
              '.inventory-display-stock-information-low-stock.icon, .inventory-display-stock-information-back-order.icon'
            )
              .removeClass()
              .addClass('product-line-stock-icon-low');
          }

          this.$('.inventory-display-quantity-available').hide();
        },
        this
      );
    })
  });
});
